/** YieldNest WithdrawalQueueManager — ERC-721 enumerable + per-id
 *  getter. Address on chain 1:
 *  `0x0bc9bc81ad379810b36ad5cc95387112990aa67b`. */
export const YieldNestWithdrawalQueueAbi = [
  {
    name: 'balanceOf',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'tokenOfOwnerByIndex',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address' }, { type: 'uint256' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'withdrawalRequest',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'tokenId' }],
    outputs: [
      {
        type: 'tuple',
        components: [
          { type: 'uint256', name: 'amount' },
          { type: 'uint256', name: 'feeAtRequestTime' },
          { type: 'uint256', name: 'redemptionRateAtRequestTime' },
          { type: 'uint256', name: 'creationTimestamp' },
          { type: 'bool', name: 'processed' },
          { type: 'bytes', name: 'data' },
        ],
      },
    ],
  },
  {
    name: 'secondsToFinalization',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
